
const TileCard = (props) => {
    return <div className={`border h-52 rounded-lg shadow text-gray-800 bg-[#f3f9fe] ${props.classNames ? props.classNames : ''}`}>
                {props.children}
    </div>
}

export default TileCard